import { Block, Headline, Link, Text } from '@upsales/components';
import logError from 'Helpers/logError';
import { makeCancelable } from 'Helpers/promise';
import React, { useEffect, useState } from 'react';
import TipResource from 'Resources/Tip';
import T from 'Components/Helpers/translate';
import './LoginTip.scss';
import BemClass from '@upsales/components/Utils/bemClass';
import { DefaultButton } from '@upsales/components/Buttons';

type Tip = {
	type: string;
	title: string;
	description: string;
	link: string;
};

export default function LoginTip() {
	const classes = new BemClass('LoginTip');
	const [tip, setTip] = useState<null | Tip>(null);
	useEffect(() => {
		const getter = makeCancelable<{ data: Tip }>(TipResource.getRandomTip());
		getter.promise
			.then(({ data }) => {
				setTip(
					data
						? data
						: {
								type: '',
								title: 'Find out more about the Upsales revenue engine',
								description:
									'The fastest growing B2B companies use CRM, Marketing Automation and Analytics from Upsales to reach new customers and win more deals.',
								link: 'https://www.upsales.com'
						  }
				);
			})
			.catch(e => logError(e, 'Failed to fetch random tip'));

		return () => {
			getter.cancel();
		};
	}, []);

	return tip ? (
		<Block className={classes.b()}>
			<Block space="mbl">
				<Text color="yellow-3" size="sm" className={classes.elem('header').b()}>
					{tip.type}
				</Text>
			</Block>
			<Headline size="sm" color="super-light-green">
				{tip.title}
			</Headline>
			<Block space="mtl mbxl">
				<Text color="super-light-green">{tip.description}</Text>
			</Block>

			<Link nostyle href={tip.link} target="_blank">
				<DefaultButton size="lg">{T('default.readMore')}</DefaultButton>
			</Link>
		</Block>
	) : null;
}
